module.exports = __webpack_public_path__ + "img/banner genérico-03.5b14ea4d.jpg";